export const approvedOrgs: string[] = [
    "GM-IT",
    "GM-INNERSOURCE",
    "GENERALMOTORS-IT",
    "GM-ADAS",
    "GM-ATMOS",
    "GM-CRUISE-ADIM",
    "GM-COMMERCIAL",
    "GM-DATA-ENG",
    "GM-DBT",
    "GM-DEVELOPERDAY",
    "GM-GMOS",
    "GM-GPD",
    "GM-GPD-DEVTEST",
    "GM-IT-DEVTEST",
    "GM-IT-ISRM",
    "GM-PVO",
    "GM-SDV",
    "GM-SDV-EP",
    "GM-SDV-EP-DEVTEST",
    "GM-SDV-OS-DEVTEST",
    "GM-SDV-UP",
    "GM-SDV-UP-DEVTEST",
    "GM-SI",
    "GM-SI-DEVTEST",
    "GM-SNOW-TEST",
    "GM-SUPPLIER-SHARE",
    "GM-VIQ",
    "GM-VEH-CYBR",
    "GM-TERRAFORM-CLOUD-POC",
    "SDV-DEVTEST",
    "SDV-EP-OTA"
  ];